const NODES = [
  { x: 80, y: 120 },
  { x: 220, y: 300 },
  { x: 400, y: 90 },
  { x: 500, y: 350 },
  { x: 650, y: 180 },
  { x: 780, y: 420 },
  { x: 900, y: 150 },
  { x: 150, y: 480 },
  { x: 350, y: 520 },
  { x: 850, y: 300 },
];

const LINKS = [
  [0, 1],
  [1, 2],
  [2, 4],
  [4, 6],
  [1, 8],
  [8, 3],
  [3, 4],
  [4, 5],
  [5, 9],
  [7, 8],
];

const PACKET_LINKS = [
  [1, 2],
  [4, 5],
  [1, 8],
];

const NetworkOverlay = () => (
  <svg
    viewBox="0 0 1000 600"
    preserveAspectRatio="none"
    className="absolute inset-0 h-full w-full"
    aria-hidden="true"
  >
    {LINKS.map(([a, b], i) => (
      <line
        key={i}
        x1={NODES[a].x}
        y1={NODES[a].y}
        x2={NODES[b].x}
        y2={NODES[b].y}
        className="stroke-[rgba(var(--website-secondary-rgb),0.28)]"
        strokeWidth="1"
      />
    ))}

    {PACKET_LINKS.map(([a, b], i) => {
      const dx = NODES[b].x - NODES[a].x;
      const dy = NODES[b].y - NODES[a].y;
      return (
        <circle
          key={`packet-${i}`}
          cx={NODES[a].x}
          cy={NODES[a].y}
          r="3"
          className="network-packet fill-[var(--website-secondary-color)]"
          style={{
            "--dx": `${dx}px`,
            "--dy": `${dy}px`,
            animationDuration: `${4 + i}s`,
            animationDelay: `${i * 0.8}s`,
          }}
        />
      );
    })}

    {NODES.map((node, i) => (
      <circle
        key={i}
        cx={node.x}
        cy={node.y}
        r="4"
        className="network-node fill-[var(--website-secondary-color)]"
        style={{ animationDelay: `${i * 0.25}s` }}
      />
    ))}
  </svg>
);

export default NetworkOverlay;
